import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-white border-t mt-20 transition-opacity duration-500">

      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10 text-sm">

        {/* BRAND */}
        <div>
          <h2 className="text-2xl font-serif italic mb-3">isabi</h2>
          <p className="text-stone-500 text-sm">
            Handcrafted spiritual art designed to bring peace, devotion, and beauty into your home.
          </p>
        </div>

        {/* SHOP */}
        <div>
          <h3 className="font-semibold mb-3">Shop</h3>
          <ul className="space-y-2 text-stone-500">
            <li><Link to="/products" className="hover:text-black">All Products</Link></li>
            <li><Link to="/" className="hover:text-black">Collections</Link></li>
            <li><Link to="/support" className="hover:text-black">Custom Orders</Link></li>
          </ul>
        </div>

        {/* SUPPORT */}
        <div>
          <h3 className="font-semibold mb-3">Support</h3>
          <ul className="space-y-2 text-stone-500">
            <li><Link to="/support" className="hover:text-black">Contact</Link></li>
            <li><Link to="/orders" className="hover:text-black">Orders</Link></li>
            <li><Link to="/track-order" className="hover:text-black">Order Tracking</Link></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h3 className="font-semibold mb-3">Contact</h3>
          <p className="text-stone-500 text-sm mb-2">
            📧 connect@isabistudio.com
          </p>
          <p className="text-stone-500 text-sm">
            📱 +91 XXXXX XXXXX
          </p>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="border-t border-stone-200 text-center text-xs text-stone-400 py-6 uppercase tracking-widest">
        © 2026 Isabi Studio • Crafted with devotion
      </div>

    </footer>
  );
}

export default Footer;